import { useState } from "react"
import { Button } from "@mui/material"
import { useSnackbar } from "notistack"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { moveMaintenanceTask } from "../../controller/maintenance-library"

export function MoveButton({ task, onMoved }) {
    const { target } = useBoundContext()
    const { enqueueSnackbar } = useSnackbar()
    const [processing, setProcessing] = useState(false)

    return (
        <Button
            variant="contained"
            color="primary"
            disabled={!target.newCategoryId || processing}
            onClick={handleClick}
        >
            Move
        </Button>
    )

    async function handleClick() {
        const newCategoryId = target.newCategoryId?.id || target.newCategoryId
        if (!newCategoryId) return
        setProcessing(true)
        try {
            await moveMaintenanceTask(task.id, newCategoryId)
            const folderName = target.newCategoryId?.name || "folder"
            enqueueSnackbar(`Component moved to ${folderName}`)
            onMoved()
        } catch (error) {
            enqueueSnackbar(error.message || "Failed to move component", { variant: "error" })
        } finally {
            setProcessing(false)
        }
    }
}
